// AUTO-GENERATED by scripts/brand-assets-inventory.mjs — do not hand-edit.
// STAGING-LAUNCH-READINESS-002-R2-R4 — verified brand logo manifest.
// Mirrors apps/mini-app/public/brand-logos/manifest.json exactly.
import type { BrandLogoRecord } from "./brand-logo-registry-v2.js";

export const BRAND_LOGO_MANIFEST_GENERATED_AT = "2026-07-25T16:44:08.807Z";

export const GENERATED_VERIFIED_BRAND_LOGOS: BrandLogoRecord[] = [
  {
    "canonical_slug": "acecook",
    "brand_name": "Acecook",
    "local_asset_path": "/brand-logos/acecook/61e76b3cc1a9bd7663a031a5a93aad4dd8e63b785830da50356a3e6639376b9d.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "61e76b3cc1a9bd7663a031a5a93aad4dd8e63b785830da50356a3e6639376b9d",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "61e76b3cc1a9bd7663a031a5a93aad4dd8e63b785830da50356a3e6639376b9d"
  },
  {
    "canonical_slug": "ajinomoto-oyakata",
    "brand_name": "Ajinomoto Oyakata",
    "local_asset_path": "/brand-logos/ajinomoto-oyakata/02593c758d4a7740a1fc44ad73d17d8ea9271c16728340f04df4d872da2e3b84.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "02593c758d4a7740a1fc44ad73d17d8ea9271c16728340f04df4d872da2e3b84",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "02593c758d4a7740a1fc44ad73d17d8ea9271c16728340f04df4d872da2e3b84"
  },
  {
    "canonical_slug": "alpro",
    "brand_name": "Alpro",
    "local_asset_path": "/brand-logos/alpro/ec7dc2d6fd5d67304ee8ca277497724782c2b3deb610e0c0caa714ee0ac1d4aa.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ec7dc2d6fd5d67304ee8ca277497724782c2b3deb610e0c0caa714ee0ac1d4aa",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ec7dc2d6fd5d67304ee8ca277497724782c2b3deb610e0c0caa714ee0ac1d4aa"
  },
  {
    "canonical_slug": "aroy-d",
    "brand_name": "Aroy-D",
    "local_asset_path": "/brand-logos/aroy-d/27213093c96c5d829ebf4382e15b331e2bd219676c4fc857422efc8bb72e03fd.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "27213093c96c5d829ebf4382e15b331e2bd219676c4fc857422efc8bb72e03fd",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "27213093c96c5d829ebf4382e15b331e2bd219676c4fc857422efc8bb72e03fd"
  },
  {
    "canonical_slug": "asian-choice",
    "brand_name": "Asian Choice",
    "local_asset_path": "/brand-logos/asian-choice/92088c1e965df2e67c57bc44435bf41097016836e2b01f79e81f628e0bf9aa0c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "92088c1e965df2e67c57bc44435bf41097016836e2b01f79e81f628e0bf9aa0c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "92088c1e965df2e67c57bc44435bf41097016836e2b01f79e81f628e0bf9aa0c"
  },
  {
    "canonical_slug": "aumi",
    "brand_name": "AUMI",
    "local_asset_path": "/brand-logos/aumi/d9ca93b3d9280d6b3315329405023a60710aee62d345c6a52b59a145ef3ad277.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "d9ca93b3d9280d6b3315329405023a60710aee62d345c6a52b59a145ef3ad277",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "d9ca93b3d9280d6b3315329405023a60710aee62d345c6a52b59a145ef3ad277"
  },
  {
    "canonical_slug": "baijia",
    "brand_name": "Baijia",
    "local_asset_path": "/brand-logos/baijia/a82bc7dff1aee038e5ba41dff4e7b24a44131aa61dd4607226e1dfadcf2d0886.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a82bc7dff1aee038e5ba41dff4e7b24a44131aa61dd4607226e1dfadcf2d0886",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a82bc7dff1aee038e5ba41dff4e7b24a44131aa61dd4607226e1dfadcf2d0886"
  },
  {
    "canonical_slug": "baixiang",
    "brand_name": "Baixiang",
    "local_asset_path": "/brand-logos/baixiang/fe69aa5d3adfad69de1e6ce1500070e36afcfabc558d860459768b9399c821f4.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "fe69aa5d3adfad69de1e6ce1500070e36afcfabc558d860459768b9399c821f4",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "fe69aa5d3adfad69de1e6ce1500070e36afcfabc558d860459768b9399c821f4"
  },
  {
    "canonical_slug": "bamboo-house",
    "brand_name": "Bamboo House",
    "local_asset_path": "/brand-logos/bamboo-house/bcbe64087c46b8e3f5daabb15fd7d0d3f30d4a02c456961bf2a86332f59d0a94.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "bcbe64087c46b8e3f5daabb15fd7d0d3f30d4a02c456961bf2a86332f59d0a94",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "bcbe64087c46b8e3f5daabb15fd7d0d3f30d4a02c456961bf2a86332f59d0a94"
  },
  {
    "canonical_slug": "bao-long",
    "brand_name": "Bao Long",
    "local_asset_path": "/brand-logos/bao-long/9389fdc0880c734fbde53d1c4f86687b56a674a685445d83cb149f437ecf7282.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "9389fdc0880c734fbde53d1c4f86687b56a674a685445d83cb149f437ecf7282",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "9389fdc0880c734fbde53d1c4f86687b56a674a685445d83cb149f437ecf7282"
  },
  {
    "canonical_slug": "bich-chi",
    "brand_name": "Bich-Chi",
    "local_asset_path": "/brand-logos/bich-chi/a5cbe0fb64fc3a1ddeba22e77cd01b4781fd8b3581f9b7fa94760ac98545e880.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a5cbe0fb64fc3a1ddeba22e77cd01b4781fd8b3581f9b7fa94760ac98545e880",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a5cbe0fb64fc3a1ddeba22e77cd01b4781fd8b3581f9b7fa94760ac98545e880"
  },
  {
    "canonical_slug": "chacha",
    "brand_name": "ChaCha",
    "local_asset_path": "/brand-logos/chacha/d5fafae48d3f7f542dd45f5d287e8af8077ab596dd46ed5d1ccbb447e734de3c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "d5fafae48d3f7f542dd45f5d287e8af8077ab596dd46ed5d1ccbb447e734de3c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "d5fafae48d3f7f542dd45f5d287e8af8077ab596dd46ed5d1ccbb447e734de3c"
  },
  {
    "canonical_slug": "chaosheng",
    "brand_name": "ChaoSheng",
    "local_asset_path": "/brand-logos/chaosheng/e048f0557bc4bc1623ba458229fdfcd766b090cc18bcad2e72750ffd6d84cea0.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "e048f0557bc4bc1623ba458229fdfcd766b090cc18bcad2e72750ffd6d84cea0",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "e048f0557bc4bc1623ba458229fdfcd766b090cc18bcad2e72750ffd6d84cea0"
  },
  {
    "canonical_slug": "chin-su",
    "brand_name": "CHIN-SU",
    "local_asset_path": "/brand-logos/chin-su/3f71e4a0244c792807a281b82325d36d8d76337d299d6323ed72b28e23b3e0e5.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "3f71e4a0244c792807a281b82325d36d8d76337d299d6323ed72b28e23b3e0e5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "3f71e4a0244c792807a281b82325d36d8d76337d299d6323ed72b28e23b3e0e5"
  },
  {
    "canonical_slug": "chupa-chups",
    "brand_name": "Chupa Chups",
    "local_asset_path": "/brand-logos/chupa-chups/29d302c1a85742b5930e652fcf3848f6390be2cf8f8c0cc09bcef83cd083324b.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "29d302c1a85742b5930e652fcf3848f6390be2cf8f8c0cc09bcef83cd083324b",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "29d302c1a85742b5930e652fcf3848f6390be2cf8f8c0cc09bcef83cd083324b"
  },
  {
    "canonical_slug": "coca-cola",
    "brand_name": "Coca-Cola",
    "local_asset_path": "/brand-logos/coca-cola/e5776757624972ff7b40759ee633082760eeeabab193cacac68fdf2e588b1c57.svg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "e5776757624972ff7b40759ee633082760eeeabab193cacac68fdf2e588b1c57",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "e5776757624972ff7b40759ee633082760eeeabab193cacac68fdf2e588b1c57"
  },
  {
    "canonical_slug": "cock-brand",
    "brand_name": "Cock Brand",
    "local_asset_path": "/brand-logos/cock-brand/15b6d8763df308c98f036752bbbbef756d5dd1948868fd290de06ffcdad1130e.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "15b6d8763df308c98f036752bbbbef756d5dd1948868fd290de06ffcdad1130e",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "15b6d8763df308c98f036752bbbbef756d5dd1948868fd290de06ffcdad1130e"
  },
  {
    "canonical_slug": "cokoc",
    "brand_name": "Cokoc",
    "local_asset_path": "/brand-logos/cokoc/ed6eeb56e26c21d7ddf4815babcb63d25b99e57dae35c6118bfd2c18977bbb96.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ed6eeb56e26c21d7ddf4815babcb63d25b99e57dae35c6118bfd2c18977bbb96",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ed6eeb56e26c21d7ddf4815babcb63d25b99e57dae35c6118bfd2c18977bbb96"
  },
  {
    "canonical_slug": "crying-thaiger",
    "brand_name": "Crying Thaiger",
    "local_asset_path": "/brand-logos/crying-thaiger/daee354283f612521e21bdce113efcb4b68a14ed6ecc2f94547f288702f49218.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "daee354283f612521e21bdce113efcb4b68a14ed6ecc2f94547f288702f49218",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "daee354283f612521e21bdce113efcb4b68a14ed6ecc2f94547f288702f49218"
  },
  {
    "canonical_slug": "daisho",
    "brand_name": "Daisho",
    "local_asset_path": "/brand-logos/daisho/461dcf291e6abe8a0f9decc71933f3de58d0bedc63bf7122cbfc789f7de39aac.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "461dcf291e6abe8a0f9decc71933f3de58d0bedc63bf7122cbfc789f7de39aac",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "461dcf291e6abe8a0f9decc71933f3de58d0bedc63bf7122cbfc789f7de39aac"
  },
  {
    "canonical_slug": "encona",
    "brand_name": "Encona",
    "local_asset_path": "/brand-logos/encona/ffcd75528d0635bf166a458b8039eeb6d1c48006ceae3fc01f99999d407d17b6.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ffcd75528d0635bf166a458b8039eeb6d1c48006ceae3fc01f99999d407d17b6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ffcd75528d0635bf166a458b8039eeb6d1c48006ceae3fc01f99999d407d17b6"
  },
  {
    "canonical_slug": "fanta",
    "brand_name": "Fanta",
    "local_asset_path": "/brand-logos/fanta/de16736406bfdccc9181e5df384046d645457475b79a9fac6bb248d6963711b2.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "de16736406bfdccc9181e5df384046d645457475b79a9fac6bb248d6963711b2",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "de16736406bfdccc9181e5df384046d645457475b79a9fac6bb248d6963711b2"
  },
  {
    "canonical_slug": "farmer-brand",
    "brand_name": "Farmer Brand",
    "local_asset_path": "/brand-logos/farmer-brand/13e767be190602f093c5b529b11d1be52571022dd95338e0decc55a418934c7a.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "13e767be190602f093c5b529b11d1be52571022dd95338e0decc55a418934c7a",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "13e767be190602f093c5b529b11d1be52571022dd95338e0decc55a418934c7a"
  },
  {
    "canonical_slug": "flying-goose",
    "brand_name": "Flying Goose",
    "local_asset_path": "/brand-logos/flying-goose/f3a81d88320f02c6a2a63b2faf2eded51548548d3341cb8f5626965cdb3f2f8b.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "f3a81d88320f02c6a2a63b2faf2eded51548548d3341cb8f5626965cdb3f2f8b",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "f3a81d88320f02c6a2a63b2faf2eded51548548d3341cb8f5626965cdb3f2f8b"
  },
  {
    "canonical_slug": "glico",
    "brand_name": "Glico",
    "local_asset_path": "/brand-logos/glico/b93c621af75fe8ad76ab6aff10269c45816f85055e2af04c70e11c11a305d9bb.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "b93c621af75fe8ad76ab6aff10269c45816f85055e2af04c70e11c11a305d9bb",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "b93c621af75fe8ad76ab6aff10269c45816f85055e2af04c70e11c11a305d9bb"
  },
  {
    "canonical_slug": "golden-turtle",
    "brand_name": "Golden Turtle",
    "local_asset_path": "/brand-logos/golden-turtle/99b7f7eac7e7d7ee797b8d1bfd76688ea20eb4f202ca573c11296fc3f53666a1.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "99b7f7eac7e7d7ee797b8d1bfd76688ea20eb4f202ca573c11296fc3f53666a1",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "99b7f7eac7e7d7ee797b8d1bfd76688ea20eb4f202ca573c11296fc3f53666a1"
  },
  {
    "canonical_slug": "haday",
    "brand_name": "Haday",
    "local_asset_path": "/brand-logos/haday/d018146af2e252efb06eaa51a4f1858450a93a3059a194ead1194522725f59b7.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "d018146af2e252efb06eaa51a4f1858450a93a3059a194ead1194522725f59b7",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "d018146af2e252efb06eaa51a4f1858450a93a3059a194ead1194522725f59b7"
  },
  {
    "canonical_slug": "haidilao",
    "brand_name": "Haidilao",
    "local_asset_path": "/brand-logos/haidilao/21ba4385bccd85e522809423acec05c184973c5a4b125b16a7fae6e29c292372.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "21ba4385bccd85e522809423acec05c184973c5a4b125b16a7fae6e29c292372",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "21ba4385bccd85e522809423acec05c184973c5a4b125b16a7fae6e29c292372"
  },
  {
    "canonical_slug": "happy-belly",
    "brand_name": "Happy Belly",
    "local_asset_path": "/brand-logos/happy-belly/fa187f05a02c312ce19169a936328038132f6f0726703a501f0df97d0de070a2.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "fa187f05a02c312ce19169a936328038132f6f0726703a501f0df97d0de070a2",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "fa187f05a02c312ce19169a936328038132f6f0726703a501f0df97d0de070a2"
  },
  {
    "canonical_slug": "haribo",
    "brand_name": "Haribo",
    "local_asset_path": "/brand-logos/haribo/633c28ba1331ed00343a93cd3b99397326f36dec26350a7be8321804e9256f55.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "633c28ba1331ed00343a93cd3b99397326f36dec26350a7be8321804e9256f55",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "633c28ba1331ed00343a93cd3b99397326f36dec26350a7be8321804e9256f55"
  },
  {
    "canonical_slug": "hata",
    "brand_name": "Hata",
    "local_asset_path": "/brand-logos/hata/d304f7680f83e454addc23b305c92eea0d2a390476421ab22081b8c95d13aeb6.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "d304f7680f83e454addc23b305c92eea0d2a390476421ab22081b8c95d13aeb6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "d304f7680f83e454addc23b305c92eea0d2a390476421ab22081b8c95d13aeb6"
  },
  {
    "canonical_slug": "healthy-boy-brand",
    "brand_name": "Healthy Boy Brand",
    "local_asset_path": "/brand-logos/healthy-boy-brand/acf40bb70e74e008f9361d32210ce75dade303bb5ba559c586fcab29296de199.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "acf40bb70e74e008f9361d32210ce75dade303bb5ba559c586fcab29296de199",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "acf40bb70e74e008f9361d32210ce75dade303bb5ba559c586fcab29296de199"
  },
  {
    "canonical_slug": "heinz",
    "brand_name": "Heinz",
    "local_asset_path": "/brand-logos/heinz/7a2103d783fb5848f75562462a077ede08ff1092fcdb84022e4fd3b043822044.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "7a2103d783fb5848f75562462a077ede08ff1092fcdb84022e4fd3b043822044",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "7a2103d783fb5848f75562462a077ede08ff1092fcdb84022e4fd3b043822044"
  },
  {
    "canonical_slug": "hengshun",
    "brand_name": "Hengshun",
    "local_asset_path": "/brand-logos/hengshun/12b93723f22323d5872e0c71be5cafec1cef90a7d7de4e56fc9bf32c77cb68d6.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "12b93723f22323d5872e0c71be5cafec1cef90a7d7de4e56fc9bf32c77cb68d6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "12b93723f22323d5872e0c71be5cafec1cef90a7d7de4e56fc9bf32c77cb68d6"
  },
  {
    "canonical_slug": "house-of-asia",
    "brand_name": "House of Asia",
    "local_asset_path": "/brand-logos/house-of-asia/8af9d9cc1c5653503a301cac8097cff03b6cd89c75558d8e83aec2864aa5d506.svg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "8af9d9cc1c5653503a301cac8097cff03b6cd89c75558d8e83aec2864aa5d506",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "8af9d9cc1c5653503a301cac8097cff03b6cd89c75558d8e83aec2864aa5d506"
  },
  {
    "canonical_slug": "jongga",
    "brand_name": "Jongga",
    "local_asset_path": "/brand-logos/jongga/be7b2fef63efc8d5326e74374e7e2158c20a0619c477d4c19b476c9a0f70e64c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "be7b2fef63efc8d5326e74374e7e2158c20a0619c477d4c19b476c9a0f70e64c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "be7b2fef63efc8d5326e74374e7e2158c20a0619c477d4c19b476c9a0f70e64c"
  },
  {
    "canonical_slug": "kangshifu",
    "brand_name": "Kangshifu",
    "local_asset_path": "/brand-logos/kangshifu/876e1d2abb5159e984debfdfbf362ebf8d855c66272f149a2aedd64ee15f344b.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "876e1d2abb5159e984debfdfbf362ebf8d855c66272f149a2aedd64ee15f344b",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "876e1d2abb5159e984debfdfbf362ebf8d855c66272f149a2aedd64ee15f344b"
  },
  {
    "canonical_slug": "kewpie",
    "brand_name": "Kewpie",
    "local_asset_path": "/brand-logos/kewpie/2892ce5b0420f3d12fc1beae6aee288d91ac54725ff79bb65e257270072cefbb.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "2892ce5b0420f3d12fc1beae6aee288d91ac54725ff79bb65e257270072cefbb",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "2892ce5b0420f3d12fc1beae6aee288d91ac54725ff79bb65e257270072cefbb"
  },
  {
    "canonical_slug": "kikkoman",
    "brand_name": "Kikkoman",
    "local_asset_path": "/brand-logos/kikkoman/1b4631ce22fae288be1da0107aa5e177a354a5501d5effcd94d35d178e8a0753.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "1b4631ce22fae288be1da0107aa5e177a354a5501d5effcd94d35d178e8a0753",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "1b4631ce22fae288be1da0107aa5e177a354a5501d5effcd94d35d178e8a0753"
  },
  {
    "canonical_slug": "kinder",
    "brand_name": "Kinder",
    "local_asset_path": "/brand-logos/kinder/1ed1fd95fd06583a2371cac9c3033fabde8215725a7128336bc7936836c46577.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "1ed1fd95fd06583a2371cac9c3033fabde8215725a7128336bc7936836c46577",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "1ed1fd95fd06583a2371cac9c3033fabde8215725a7128336bc7936836c46577"
  },
  {
    "canonical_slug": "knorr",
    "brand_name": "Knorr Ч",
    "local_asset_path": "/brand-logos/knorr/b366d3f0a8c2b1de7448b6c06601abc39f4fa451dd56847bca6969282610e52c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "b366d3f0a8c2b1de7448b6c06601abc39f4fa451dd56847bca6969282610e52c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "b366d3f0a8c2b1de7448b6c06601abc39f4fa451dd56847bca6969282610e52c"
  },
  {
    "canonical_slug": "kurukahveci-mehmet-efendi",
    "brand_name": "Kurukahveci Mehmet Efendi",
    "local_asset_path": "/brand-logos/kurukahveci-mehmet-efendi/06a0fc388272239d390d678075383e26a5ddbe02a9133647b347223968a93e98.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "06a0fc388272239d390d678075383e26a5ddbe02a9133647b347223968a93e98",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "06a0fc388272239d390d678075383e26a5ddbe02a9133647b347223968a93e98"
  },
  {
    "canonical_slug": "lays",
    "brand_name": "Lay's",
    "local_asset_path": "/brand-logos/lays/6dca992110fa08b74c2ba14bda31911dcc2eaf7f7d740514ce133cff22242ab3.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "6dca992110fa08b74c2ba14bda31911dcc2eaf7f7d740514ce133cff22242ab3",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "6dca992110fa08b74c2ba14bda31911dcc2eaf7f7d740514ce133cff22242ab3"
  },
  {
    "canonical_slug": "lee-kum-kee",
    "brand_name": "Lee Kum Kee",
    "local_asset_path": "/brand-logos/lee-kum-kee/7c8969a25852fd72307c799d71a1ef7c51855a7bd3444d11998915d409190574.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "7c8969a25852fd72307c799d71a1ef7c51855a7bd3444d11998915d409190574",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "7c8969a25852fd72307c799d71a1ef7c51855a7bd3444d11998915d409190574"
  },
  {
    "canonical_slug": "lindt",
    "brand_name": "Lindt",
    "local_asset_path": "/brand-logos/lindt/cf2714b3545b782fc754328b793decd10272a96c848eb02d550f254544fa2fc2.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "cf2714b3545b782fc754328b793decd10272a96c848eb02d550f254544fa2fc2",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "cf2714b3545b782fc754328b793decd10272a96c848eb02d550f254544fa2fc2"
  },
  {
    "canonical_slug": "lipton",
    "brand_name": "Lipton",
    "local_asset_path": "/brand-logos/lipton/b0113e52381f360bdf60eb36f718f198fca02aabb567f505012aa3999037bcfc.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "b0113e52381f360bdf60eb36f718f198fca02aabb567f505012aa3999037bcfc",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "b0113e52381f360bdf60eb36f718f198fca02aabb567f505012aa3999037bcfc"
  },
  {
    "canonical_slug": "lotte",
    "brand_name": "LOTTE",
    "local_asset_path": "/brand-logos/lotte/13f512a8267c611412db57dd155f4fbcd7b893f869401fc227ad92ee0a3a938a.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "13f512a8267c611412db57dd155f4fbcd7b893f869401fc227ad92ee0a3a938a",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "13f512a8267c611412db57dd155f4fbcd7b893f869401fc227ad92ee0a3a938a"
  },
  {
    "canonical_slug": "luck-siam",
    "brand_name": "Luck Siam",
    "local_asset_path": "/brand-logos/luck-siam/ae7cca67cca28f8fe81772d29987e523ec7f41bb8010e8ee8a60621d97f91c05.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ae7cca67cca28f8fe81772d29987e523ec7f41bb8010e8ee8a60621d97f91c05",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ae7cca67cca28f8fe81772d29987e523ec7f41bb8010e8ee8a60621d97f91c05"
  },
  {
    "canonical_slug": "maekrua",
    "brand_name": "Maekrua",
    "local_asset_path": "/brand-logos/maekrua/873f6b5c2d681be1fe6ed77da2b57424fce91abfdb339eef06b7726039cf3d0f.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "873f6b5c2d681be1fe6ed77da2b57424fce91abfdb339eef06b7726039cf3d0f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "873f6b5c2d681be1fe6ed77da2b57424fce91abfdb339eef06b7726039cf3d0f"
  },
  {
    "canonical_slug": "maepranom",
    "brand_name": "Maepranom",
    "local_asset_path": "/brand-logos/maepranom/90b3c582bea4fa6c4723cbb6b3dcada1de22714bc29655c12d54a6b94fcb468b.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "90b3c582bea4fa6c4723cbb6b3dcada1de22714bc29655c12d54a6b94fcb468b",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "90b3c582bea4fa6c4723cbb6b3dcada1de22714bc29655c12d54a6b94fcb468b"
  },
  {
    "canonical_slug": "maggi",
    "brand_name": "Maggi",
    "local_asset_path": "/brand-logos/maggi/32769abc4f8ac61c841ed47f4719a4231af0f82504c11a36700be375938c7bb5.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "32769abc4f8ac61c841ed47f4719a4231af0f82504c11a36700be375938c7bb5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "32769abc4f8ac61c841ed47f4719a4231af0f82504c11a36700be375938c7bb5"
  },
  {
    "canonical_slug": "maling",
    "brand_name": "Maling",
    "local_asset_path": "/brand-logos/maling/151d679afd393018f02224dc36979c38d340c5f8fb2e5af9b2aa6485a338209a.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "151d679afd393018f02224dc36979c38d340c5f8fb2e5af9b2aa6485a338209a",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "151d679afd393018f02224dc36979c38d340c5f8fb2e5af9b2aa6485a338209a"
  },
  {
    "canonical_slug": "mama",
    "brand_name": "Mama",
    "local_asset_path": "/brand-logos/mama/c015a03dae0bfae335141ce9dc256be90eefe1fce336fb4858af2b59a54496c3.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c015a03dae0bfae335141ce9dc256be90eefe1fce336fb4858af2b59a54496c3",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c015a03dae0bfae335141ce9dc256be90eefe1fce336fb4858af2b59a54496c3"
  },
  {
    "canonical_slug": "matamun",
    "brand_name": "MATAMUN",
    "local_asset_path": "/brand-logos/matamun/a1170774592bf86e91ae9788ffff6f8fc097f2225558eb95eea185a4cbe9004f.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a1170774592bf86e91ae9788ffff6f8fc097f2225558eb95eea185a4cbe9004f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a1170774592bf86e91ae9788ffff6f8fc097f2225558eb95eea185a4cbe9004f"
  },
  {
    "canonical_slug": "meco",
    "brand_name": "Meco",
    "local_asset_path": "/brand-logos/meco/3fdac285aa5bbfbe9af215464a5938efc0413da96f676847d746031e0172fccf.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "3fdac285aa5bbfbe9af215464a5938efc0413da96f676847d746031e0172fccf",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "3fdac285aa5bbfbe9af215464a5938efc0413da96f676847d746031e0172fccf"
  },
  {
    "canonical_slug": "meiji",
    "brand_name": "Meiji",
    "local_asset_path": "/brand-logos/meiji/c4fddbf4bd351ce0351f87853a7b97de7636581fb0dc65b9c2e359834b924a07.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c4fddbf4bd351ce0351f87853a7b97de7636581fb0dc65b9c2e359834b924a07",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c4fddbf4bd351ce0351f87853a7b97de7636581fb0dc65b9c2e359834b924a07"
  },
  {
    "canonical_slug": "molfar",
    "brand_name": "MOL'FAR",
    "local_asset_path": "/brand-logos/molfar/3a3772a35197ff5d4881d111b2cadd8c6ef598486592f90ab9cc2c4179656359.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "3a3772a35197ff5d4881d111b2cadd8c6ef598486592f90ab9cc2c4179656359",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "3a3772a35197ff5d4881d111b2cadd8c6ef598486592f90ab9cc2c4179656359"
  },
  {
    "canonical_slug": "moms-dry-noodle",
    "brand_name": "Mom's Dry Noodle",
    "local_asset_path": "/brand-logos/moms-dry-noodle/e44dabfcf8547b0d330c4f3111994115d6dfbfbac8663082f034ac562f4b9d80.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "e44dabfcf8547b0d330c4f3111994115d6dfbfbac8663082f034ac562f4b9d80",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "e44dabfcf8547b0d330c4f3111994115d6dfbfbac8663082f034ac562f4b9d80"
  },
  {
    "canonical_slug": "monster-energy",
    "brand_name": "Monster Energy",
    "local_asset_path": "/brand-logos/monster-energy/a987ac1312ac0abe709870a80f45d2051fa6d17e42bb29962e561679718cd3ef.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a987ac1312ac0abe709870a80f45d2051fa6d17e42bb29962e561679718cd3ef",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a987ac1312ac0abe709870a80f45d2051fa6d17e42bb29962e561679718cd3ef"
  },
  {
    "canonical_slug": "nestle",
    "brand_name": "Nestlé",
    "local_asset_path": "/brand-logos/nestle/4b6f0f0cb07d836424d34fd75101e4339095468737e7a8eed87aa13e5300031d.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "4b6f0f0cb07d836424d34fd75101e4339095468737e7a8eed87aa13e5300031d",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "4b6f0f0cb07d836424d34fd75101e4339095468737e7a8eed87aa13e5300031d"
  },
  {
    "canonical_slug": "nokchawon",
    "brand_name": "NOKCHAWON",
    "local_asset_path": "/brand-logos/nokchawon/a1fcd80c9ddf8ccc38d4a1032bbc5577de4ac8f7ec93e5037613b6500d99f29b.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a1fcd80c9ddf8ccc38d4a1032bbc5577de4ac8f7ec93e5037613b6500d99f29b",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a1fcd80c9ddf8ccc38d4a1032bbc5577de4ac8f7ec93e5037613b6500d99f29b"
  },
  {
    "canonical_slug": "nongshim",
    "brand_name": "Nongshim",
    "local_asset_path": "/brand-logos/nongshim/0e52d1abfeef6cb2a9b178eca2b972134800085483dd17398d07de89abd104bc.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "0e52d1abfeef6cb2a9b178eca2b972134800085483dd17398d07de89abd104bc",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "0e52d1abfeef6cb2a9b178eca2b972134800085483dd17398d07de89abd104bc"
  },
  {
    "canonical_slug": "ofood",
    "brand_name": "O'Food",
    "local_asset_path": "/brand-logos/ofood/a13e8e7d9fb305fd257a76683aeac9e939e788d48f48f64b28471bf4c4f4babc.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a13e8e7d9fb305fd257a76683aeac9e939e788d48f48f64b28471bf4c4f4babc",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a13e8e7d9fb305fd257a76683aeac9e939e788d48f48f64b28471bf4c4f4babc"
  },
  {
    "canonical_slug": "oreo",
    "brand_name": "Oreo",
    "local_asset_path": "/brand-logos/oreo/23d532cbf10bc355dc1159958cd31d9ca92bde9f468cea4cad712d666f3c938d.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "23d532cbf10bc355dc1159958cd31d9ca92bde9f468cea4cad712d666f3c938d",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "23d532cbf10bc355dc1159958cd31d9ca92bde9f468cea4cad712d666f3c938d"
  },
  {
    "canonical_slug": "orion",
    "brand_name": "Orion",
    "local_asset_path": "/brand-logos/orion/99f9bfa17b5a1e3226d4cfbf366f31462d8cb02791eea293df56b58bb0a65599.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "99f9bfa17b5a1e3226d4cfbf366f31462d8cb02791eea293df56b58bb0a65599",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "99f9bfa17b5a1e3226d4cfbf366f31462d8cb02791eea293df56b58bb0a65599"
  },
  {
    "canonical_slug": "otafuku",
    "brand_name": "Otafuku",
    "local_asset_path": "/brand-logos/otafuku/b315bffaccd3077e78845cde93f1042e80790f0af35997cd9a7ebc9ae8f4f6e5.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "b315bffaccd3077e78845cde93f1042e80790f0af35997cd9a7ebc9ae8f4f6e5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "b315bffaccd3077e78845cde93f1042e80790f0af35997cd9a7ebc9ae8f4f6e5"
  },
  {
    "canonical_slug": "otoki",
    "brand_name": "Otoki",
    "local_asset_path": "/brand-logos/otoki/f966d4a27251ac9316d8154f23ee9fd7d8714ade84b2c491b3842d7646007f23.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "f966d4a27251ac9316d8154f23ee9fd7d8714ade84b2c491b3842d7646007f23",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "f966d4a27251ac9316d8154f23ee9fd7d8714ade84b2c491b3842d7646007f23"
  },
  {
    "canonical_slug": "ottogi",
    "brand_name": "Ottogi",
    "local_asset_path": "/brand-logos/ottogi/441cf1b8a931649bd18f7a1ae0c8097313b89197d02b9de8a004b516da4a70e6.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "441cf1b8a931649bd18f7a1ae0c8097313b89197d02b9de8a004b516da4a70e6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "441cf1b8a931649bd18f7a1ae0c8097313b89197d02b9de8a004b516da4a70e6"
  },
  {
    "canonical_slug": "paldo",
    "brand_name": "Paldo",
    "local_asset_path": "/brand-logos/paldo/f08b13fe42e9472e3993ffc9d8afb87f26c0f850912397055df5ae3d1337878f.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "f08b13fe42e9472e3993ffc9d8afb87f26c0f850912397055df5ae3d1337878f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "f08b13fe42e9472e3993ffc9d8afb87f26c0f850912397055df5ae3d1337878f"
  },
  {
    "canonical_slug": "pantai-norasingh",
    "brand_name": "Pantai Norasingh",
    "local_asset_path": "/brand-logos/pantai-norasingh/d45ab6ff0b938eda2d1ba32d49e60f4a8f8a8561ccc2c27615375c24d7b17bc8.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "d45ab6ff0b938eda2d1ba32d49e60f4a8f8a8561ccc2c27615375c24d7b17bc8",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "d45ab6ff0b938eda2d1ba32d49e60f4a8f8a8561ccc2c27615375c24d7b17bc8"
  },
  {
    "canonical_slug": "penta",
    "brand_name": "Penta",
    "local_asset_path": "/brand-logos/penta/fce1a0504a2bd2bccaa1dd195333262c7d386d2d032742aa0aaf83fb6b6def3e.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "fce1a0504a2bd2bccaa1dd195333262c7d386d2d032742aa0aaf83fb6b6def3e",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "fce1a0504a2bd2bccaa1dd195333262c7d386d2d032742aa0aaf83fb6b6def3e"
  },
  {
    "canonical_slug": "por-kwan",
    "brand_name": "Por Kwan",
    "local_asset_path": "/brand-logos/por-kwan/a9853e37eb07c757b90db39cb5323bbf07ea0eb9f9e823b611dbf46728aa58a0.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a9853e37eb07c757b90db39cb5323bbf07ea0eb9f9e823b611dbf46728aa58a0",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a9853e37eb07c757b90db39cb5323bbf07ea0eb9f9e823b611dbf46728aa58a0"
  },
  {
    "canonical_slug": "prao-hom",
    "brand_name": "Prao Hom",
    "local_asset_path": "/brand-logos/prao-hom/c7b7a7f70704546aa73321d03da04bd69ac13f61676384448f12f373341f7c6c.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c7b7a7f70704546aa73321d03da04bd69ac13f61676384448f12f373341f7c6c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c7b7a7f70704546aa73321d03da04bd69ac13f61676384448f12f373341f7c6c"
  },
  {
    "canonical_slug": "rico",
    "brand_name": "Rico",
    "local_asset_path": "/brand-logos/rico/2b486d1235041c8a87feddc45d10fdfac41e1b00407bd0b8e466984d2f576de9.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "2b486d1235041c8a87feddc45d10fdfac41e1b00407bd0b8e466984d2f576de9",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "2b486d1235041c8a87feddc45d10fdfac41e1b00407bd0b8e466984d2f576de9"
  },
  {
    "canonical_slug": "royal-family",
    "brand_name": "Royal Family",
    "local_asset_path": "/brand-logos/royal-family/51819d2fcb7ab98b7cd42459c8e96120ad3cd48a575b266d50358e3af14c83ca.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "51819d2fcb7ab98b7cd42459c8e96120ad3cd48a575b266d50358e3af14c83ca",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "51819d2fcb7ab98b7cd42459c8e96120ad3cd48a575b266d50358e3af14c83ca"
  },
  {
    "canonical_slug": "sa-giang",
    "brand_name": "Sa Giang",
    "local_asset_path": "/brand-logos/sa-giang/9586bb1481cd520009cbe0ae18067e953d153d72b68be65f4d074ac753bf247d.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "9586bb1481cd520009cbe0ae18067e953d153d72b68be65f4d074ac753bf247d",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "9586bb1481cd520009cbe0ae18067e953d153d72b68be65f4d074ac753bf247d"
  },
  {
    "canonical_slug": "samyang",
    "brand_name": "Samyang",
    "local_asset_path": "/brand-logos/samyang/2ec3ad6df65d473682910900f52dfc79ee2a0e5394d5f1b0a692af820e479ef4.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "2ec3ad6df65d473682910900f52dfc79ee2a0e5394d5f1b0a692af820e479ef4",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "2ec3ad6df65d473682910900f52dfc79ee2a0e5394d5f1b0a692af820e479ef4"
  },
  {
    "canonical_slug": "sempio",
    "brand_name": "Sempio",
    "local_asset_path": "/brand-logos/sempio/57f2ac074d883c7b080fd525babd4a0051bead74efa721c9b35869b33d78ffed.jpg",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "57f2ac074d883c7b080fd525babd4a0051bead74efa721c9b35869b33d78ffed",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "57f2ac074d883c7b080fd525babd4a0051bead74efa721c9b35869b33d78ffed"
  },
  {
    "canonical_slug": "spring-home-tyj",
    "brand_name": "Spring Home TYJ",
    "local_asset_path": "/brand-logos/spring-home-tyj/21fd1e2421ec5a29648d00d5588c6bc9c068b17f56ae572b90435bd0b793a3eb.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "21fd1e2421ec5a29648d00d5588c6bc9c068b17f56ae572b90435bd0b793a3eb",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "21fd1e2421ec5a29648d00d5588c6bc9c068b17f56ae572b90435bd0b793a3eb"
  },
  {
    "canonical_slug": "tan-do",
    "brand_name": "Tan Do",
    "local_asset_path": "/brand-logos/tan-do/ca6539452c8f98b8034735ffd0c38f0e1a8265258fecec9ff59a53e7b83023ee.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ca6539452c8f98b8034735ffd0c38f0e1a8265258fecec9ff59a53e7b83023ee",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ca6539452c8f98b8034735ffd0c38f0e1a8265258fecec9ff59a53e7b83023ee"
  },
  {
    "canonical_slug": "tao-kae-noi",
    "brand_name": "Tao Kae Noi",
    "local_asset_path": "/brand-logos/tao-kae-noi/18ae2f1ac6a01e2e34d993df71b7bbc92a07b6fb8ff57607f974652bedc6f17f.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "18ae2f1ac6a01e2e34d993df71b7bbc92a07b6fb8ff57607f974652bedc6f17f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "18ae2f1ac6a01e2e34d993df71b7bbc92a07b6fb8ff57607f974652bedc6f17f"
  },
  {
    "canonical_slug": "taotao",
    "brand_name": "TaoTao",
    "local_asset_path": "/brand-logos/taotao/397908e41cfb9e11c4fa7a92e02a5842626b45e07824ed01455cc684d1f29612.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "397908e41cfb9e11c4fa7a92e02a5842626b45e07824ed01455cc684d1f29612",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "397908e41cfb9e11c4fa7a92e02a5842626b45e07824ed01455cc684d1f29612"
  },
  {
    "canonical_slug": "terre-doc",
    "brand_name": "Terre d'Oc",
    "local_asset_path": "/brand-logos/terre-doc/0d4d1d1c17ef77dbd17148e3ac89a4bc08818328fa0eede540cc28299bf4ce17.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "0d4d1d1c17ef77dbd17148e3ac89a4bc08818328fa0eede540cc28299bf4ce17",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "0d4d1d1c17ef77dbd17148e3ac89a4bc08818328fa0eede540cc28299bf4ce17"
  },
  {
    "canonical_slug": "terre-exotique",
    "brand_name": "Terre Exotique",
    "local_asset_path": "/brand-logos/terre-exotique/a8693f778dfc5bd377acd7e64e1c7a9370b4374e51ee23d64359cca9dc0d6118.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a8693f778dfc5bd377acd7e64e1c7a9370b4374e51ee23d64359cca9dc0d6118",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a8693f778dfc5bd377acd7e64e1c7a9370b4374e51ee23d64359cca9dc0d6118"
  },
  {
    "canonical_slug": "terrys",
    "brand_name": "Terry's",
    "local_asset_path": "/brand-logos/terrys/0cab35861ebcf1346c68f204fd633e0777095034f44692003390edf1ce5bb4d5.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "0cab35861ebcf1346c68f204fd633e0777095034f44692003390edf1ce5bb4d5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "0cab35861ebcf1346c68f204fd633e0777095034f44692003390edf1ce5bb4d5"
  },
  {
    "canonical_slug": "thai-coco",
    "brand_name": "Thai Coco",
    "local_asset_path": "/brand-logos/thai-coco/e5beb32eb474cc3e08c155dc4fe63f2978c3c937ee8b897aee0a989153c84bd5.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "e5beb32eb474cc3e08c155dc4fe63f2978c3c937ee8b897aee0a989153c84bd5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "e5beb32eb474cc3e08c155dc4fe63f2978c3c937ee8b897aee0a989153c84bd5"
  },
  {
    "canonical_slug": "thai-pride",
    "brand_name": "Thai Pride",
    "local_asset_path": "/brand-logos/thai-pride/dfceffedc1ee673d10a475923855e28c11ddd4e46a04ddd5f6949fd0316d933c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "dfceffedc1ee673d10a475923855e28c11ddd4e46a04ddd5f6949fd0316d933c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "dfceffedc1ee673d10a475923855e28c11ddd4e46a04ddd5f6949fd0316d933c"
  },
  {
    "canonical_slug": "tiparos",
    "brand_name": "Tiparos",
    "local_asset_path": "/brand-logos/tiparos/aa26eef2a0b3e6cdc97b31f83a22c4b11d91f6ce81aeac79392e9effe1c7e43f.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "aa26eef2a0b3e6cdc97b31f83a22c4b11d91f6ce81aeac79392e9effe1c7e43f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "aa26eef2a0b3e6cdc97b31f83a22c4b11d91f6ce81aeac79392e9effe1c7e43f"
  },
  {
    "canonical_slug": "torras",
    "brand_name": "Torras",
    "local_asset_path": "/brand-logos/torras/c2cabc7e474011f1cd6078a37ddb202d3332f99e188a78ef43cc975b0f36c8f6.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c2cabc7e474011f1cd6078a37ddb202d3332f99e188a78ef43cc975b0f36c8f6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c2cabc7e474011f1cd6078a37ddb202d3332f99e188a78ef43cc975b0f36c8f6"
  },
  {
    "canonical_slug": "tymbark",
    "brand_name": "Tymbark",
    "local_asset_path": "/brand-logos/tymbark/83ec5aa920617722b42877f72cd9bf5b692f7dbb91a99f794300a8ae997f3388.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "83ec5aa920617722b42877f72cd9bf5b692f7dbb91a99f794300a8ae997f3388",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "83ec5aa920617722b42877f72cd9bf5b692f7dbb91a99f794300a8ae997f3388"
  },
  {
    "canonical_slug": "vifon",
    "brand_name": "Vifon",
    "local_asset_path": "/brand-logos/vifon/a40b30360ee71c91a46275c238131a18667d78516d6e9b936be6c40f386d978f.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a40b30360ee71c91a46275c238131a18667d78516d6e9b936be6c40f386d978f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a40b30360ee71c91a46275c238131a18667d78516d6e9b936be6c40f386d978f"
  },
  {
    "canonical_slug": "vinut",
    "brand_name": "Vinut",
    "local_asset_path": "/brand-logos/vinut/9386227e5ef56088313034ccabac3cefd47d9bdd01428d0b09975c0515fa552e.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "9386227e5ef56088313034ccabac3cefd47d9bdd01428d0b09975c0515fa552e",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "9386227e5ef56088313034ccabac3cefd47d9bdd01428d0b09975c0515fa552e"
  },
  {
    "canonical_slug": "vitamizu",
    "brand_name": "Vitamizu",
    "local_asset_path": "/brand-logos/vitamizu/1d1f1d125fcf7959b5afb3117cf9af0ff4af06c70707fade739f06f15354f02c.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "1d1f1d125fcf7959b5afb3117cf9af0ff4af06c70707fade739f06f15354f02c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "1d1f1d125fcf7959b5afb3117cf9af0ff4af06c70707fade739f06f15354f02c"
  },
  {
    "canonical_slug": "vitasoy",
    "brand_name": "Vitasoy",
    "local_asset_path": "/brand-logos/vitasoy/227b73c3117f56f2fb18d7419c1f65fb3bbf412df4e994ec1612c8b9e342bea3.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "227b73c3117f56f2fb18d7419c1f65fb3bbf412df4e994ec1612c8b9e342bea3",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "227b73c3117f56f2fb18d7419c1f65fb3bbf412df4e994ec1612c8b9e342bea3"
  },
  {
    "canonical_slug": "wadakan",
    "brand_name": "Wadakan",
    "local_asset_path": "/brand-logos/wadakan/3cd2f11c278c4d65ee773a9546add2cb6e1c0f8646d2d56255f954c42fcf67aa.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "3cd2f11c278c4d65ee773a9546add2cb6e1c0f8646d2d56255f954c42fcf67aa",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "3cd2f11c278c4d65ee773a9546add2cb6e1c0f8646d2d56255f954c42fcf67aa"
  },
  {
    "canonical_slug": "wan-ja-shan",
    "brand_name": "Wan Ja Shan",
    "local_asset_path": "/brand-logos/wan-ja-shan/f8e7ad505b9f7014abcae02360c872f556c682f883c71bfd778162d4bedebcd6.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "f8e7ad505b9f7014abcae02360c872f556c682f883c71bfd778162d4bedebcd6",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "f8e7ad505b9f7014abcae02360c872f556c682f883c71bfd778162d4bedebcd6"
  },
  {
    "canonical_slug": "wang",
    "brand_name": "Wang",
    "local_asset_path": "/brand-logos/wang/c21e16e8b68d492726dd92123f29bb806d8dcde324ab3c4bb9de3abfe38b32e1.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c21e16e8b68d492726dd92123f29bb806d8dcde324ab3c4bb9de3abfe38b32e1",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c21e16e8b68d492726dd92123f29bb806d8dcde324ab3c4bb9de3abfe38b32e1"
  },
  {
    "canonical_slug": "wangzhihe",
    "brand_name": "Wangzhihe",
    "local_asset_path": "/brand-logos/wangzhihe/a064b3b986662f83e2789baa5231712e7400984cf59d0819d2a17b716c1e6964.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "a064b3b986662f83e2789baa5231712e7400984cf59d0819d2a17b716c1e6964",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "a064b3b986662f83e2789baa5231712e7400984cf59d0819d2a17b716c1e6964"
  },
  {
    "canonical_slug": "want-want",
    "brand_name": "Want Want",
    "local_asset_path": "/brand-logos/want-want/5434bb5f4fd2676931335669b4a30abb3c4e702663c0c70b7a27d2e7ee8fb8a4.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "5434bb5f4fd2676931335669b4a30abb3c4e702663c0c70b7a27d2e7ee8fb8a4",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "5434bb5f4fd2676931335669b4a30abb3c4e702663c0c70b7a27d2e7ee8fb8a4"
  },
  {
    "canonical_slug": "weilong",
    "brand_name": "Weilong",
    "local_asset_path": "/brand-logos/weilong/37d82603c5e42091a89ce18a06ecf04c54dfc85c33c9d95cc6d284c3946a90f5.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "37d82603c5e42091a89ce18a06ecf04c54dfc85c33c9d95cc6d284c3946a90f5",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "37d82603c5e42091a89ce18a06ecf04c54dfc85c33c9d95cc6d284c3946a90f5"
  },
  {
    "canonical_slug": "werthers-original",
    "brand_name": "Werther's Original",
    "local_asset_path": "/brand-logos/werthers-original/12b5b1d01d7b9f7906d4b3993b03f4c3787f96512981f00e5cfa44c40b02fde4.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "12b5b1d01d7b9f7906d4b3993b03f4c3787f96512981f00e5cfa44c40b02fde4",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "12b5b1d01d7b9f7906d4b3993b03f4c3787f96512981f00e5cfa44c40b02fde4"
  },
  {
    "canonical_slug": "white-elephant",
    "brand_name": "White Elephant",
    "local_asset_path": "/brand-logos/white-elephant/87f8ecf18d05a483f36bd9e9d8de09d158d5f30232b507538c1bf19f2e2084ec.jfif",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "87f8ecf18d05a483f36bd9e9d8de09d158d5f30232b507538c1bf19f2e2084ec",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "87f8ecf18d05a483f36bd9e9d8de09d158d5f30232b507538c1bf19f2e2084ec"
  },
  {
    "canonical_slug": "woongjin",
    "brand_name": "Woongjin",
    "local_asset_path": "/brand-logos/woongjin/890bbdfe30f0a792dc647f24447c443df955e080166df6505548d6b3f326853f.webp",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "890bbdfe30f0a792dc647f24447c443df955e080166df6505548d6b3f326853f",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "890bbdfe30f0a792dc647f24447c443df955e080166df6505548d6b3f326853f"
  },
  {
    "canonical_slug": "wrigleys",
    "brand_name": "Wrigley's",
    "local_asset_path": "/brand-logos/wrigleys/deb71ce48e211700d07c8b91224faa92aea5cd9b22d7efa4d2e3e929a93d9024.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "deb71ce48e211700d07c8b91224faa92aea5cd9b22d7efa4d2e3e929a93d9024",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "deb71ce48e211700d07c8b91224faa92aea5cd9b22d7efa4d2e3e929a93d9024"
  },
  {
    "canonical_slug": "yamamori",
    "brand_name": "Yamamori",
    "local_asset_path": "/brand-logos/yamamori/2d93c00a18daf8ce5ebddae4fe192268c31140eddd7caadb0ca746ff570bff3c.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "2d93c00a18daf8ce5ebddae4fe192268c31140eddd7caadb0ca746ff570bff3c",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "2d93c00a18daf8ce5ebddae4fe192268c31140eddd7caadb0ca746ff570bff3c"
  },
  {
    "canonical_slug": "yamasa",
    "brand_name": "Yamasa",
    "local_asset_path": "/brand-logos/yamasa/ed778b78b7d54343faf8a6553bc1690e41f429137e95f492d2f6000cfebacabb.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "ed778b78b7d54343faf8a6553bc1690e41f429137e95f492d2f6000cfebacabb",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "ed778b78b7d54343faf8a6553bc1690e41f429137e95f492d2f6000cfebacabb"
  },
  {
    "canonical_slug": "yopokki",
    "brand_name": "Yopokki",
    "local_asset_path": "/brand-logos/yopokki/f3f2d877da60cd9a870c035114fd9728fc42a0ac4dc23a6b7021077cbf65fec3.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "f3f2d877da60cd9a870c035114fd9728fc42a0ac4dc23a6b7021077cbf65fec3",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "f3f2d877da60cd9a870c035114fd9728fc42a0ac4dc23a6b7021077cbf65fec3"
  },
  {
    "canonical_slug": "yumei",
    "brand_name": "YUMEI",
    "local_asset_path": "/brand-logos/yumei/95d0162278eddc6a13d27539a12a92375fcd2b8f002f4982ae5327a26cbfc180.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "95d0162278eddc6a13d27539a12a92375fcd2b8f002f4982ae5327a26cbfc180",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "95d0162278eddc6a13d27539a12a92375fcd2b8f002f4982ae5327a26cbfc180"
  },
  {
    "canonical_slug": "zab-mike",
    "brand_name": "Zab Mike",
    "local_asset_path": "/brand-logos/zab-mike/6b9d1e031419cae8664815f8118b0a6512a1054500439fe8dea2328f2a7462b0.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "6b9d1e031419cae8664815f8118b0a6512a1054500439fe8dea2328f2a7462b0",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "6b9d1e031419cae8664815f8118b0a6512a1054500439fe8dea2328f2a7462b0"
  },
  {
    "canonical_slug": "zandukeli",
    "brand_name": "Zandukeli",
    "local_asset_path": "/brand-logos/zandukeli/c905695c65aafe79469692bf3d21e8ed8cb59098d527af9b805827f872ea1582.png",
    "official_source": null,
    "source_type": "supplier",
    "source": "supplier_provided",
    "checksum": "c905695c65aafe79469692bf3d21e8ed8cb59098d527af9b805827f872ea1582",
    "imported_at": "2026-07-25T16:44:08.807Z",
    "usage_status": "active",
    "reviewer_status": "approved",
    "verified_at": "2026-07-25T16:44:08.807Z",
    "rights_note": "Sourced from the owner-provided curated brand-assets folder (BRAND-ASSET-PIPELINE-001). Filename matched to a real catalog-v2 brand; XLSX aliases only. No remote hotlinking. Presentation: CSS contain on white plate ≤512×512.",
    "asset_hash": "c905695c65aafe79469692bf3d21e8ed8cb59098d527af9b805827f872ea1582"
  }
];
